<template>
  <div id="app">
    <!-- 先居中 后缩放 -->
    <div
      class="gis-container"
      :style="{
        transform: 'translateX(-50%) translateY(-50%) translateZ(0) scale(' + scale + ')'
      }"
    >
      <!-- <div class="gis-container"> -->
      <Streaming></Streaming>
    </div>
    <div
      class="screen"
      :style="{
        transform: 'translateX(-50%) translateY(-50%) translateZ(0) scale(' + scale + ')'
      }"
    >
      <!-- <div class="screen"> -->
      <!-- 区域选择 -->
      <div class="header" v-show="topic!='login'">
        <Nav></Nav>
        <Clock class="clock_pos"></Clock>
        <img src="../public/img/weather/weather.png" class="closeTime" @click="closeTime" />
      </div>
      <!-- 二级导航 -->
      <NavSecond v-if="topicSecondRouter.length > 0" :router="topicSecondRouter"></NavSecond>
      <div class="gis_btn_pos">
        <GisButton></GisButton>
      </div>
      <div class="legend_pos">
        <Legend :topicLegends="topicLegends" @legendClick="legendClick"></Legend>
      </div>
      <div class="main">
        <router-view></router-view>
      </div>
    </div>
    <div
      id="layer-container"
      class="layer-container"
      :style="{
        transform: 'translateX(-50%) translateY(-50%) translateZ(0) scale(' + scale + ')'
      }"
    >
      <!-- <div id="layer-container" class="layer-container"> -->
      <!-- 此处放共用部分弹窗 -->
      <!-- <AreaSelect class="area_pos"></AreaSelect> -->
      <!-- <DateWeather
        :timeFlag="timeFlag"
        @closeTime="closeTime"
        :style="{
          zIndex: 199
        }"
      ></DateWeather> -->
    </div>
  </div>
</template>

<script>
import AllLayerConfig from './utils/configs/AllLayerConfig';
import { mapState } from 'vuex';
import Streaming from './views/Streaming.vue';
import Nav from '@/components/common/Nav';
import NavSecond from '@/components/common/NavSecond';
import Clock from '../src/components/common/Clock';
import AreaSelect from '@/components/common/AreaSelect';
import Legend from '@/components/common/Legend.vue';
import GisButton from '@/components/common/GisButton';
import DateWeather from '@/components/common/DateWeather';
import UEapi from './utils/UEapi/UEapi';
import cameraList from './utils/configs/cameraList';
import TempAddLayer from './utils/UEapi/TempAddLayer';

export default {
  name: 'App',
  components: {
    Streaming,
    Nav,
    NavSecond,
    Clock,
    AreaSelect,
    GisButton,
    Legend,
    DateWeather
  },
  data() {
    return {
      timeFlag: false, //时间天气显隐
      scale: 1,
      cameraList: cameraList, // 相机列表
      legends: null,
      topicLegends: [], // 当前主题的图例数据，发送给图例组件
      hideLegneds: [],
      topicSecondRouter: [] // 当前主题的二级路由
    };
  },
  methods: {
    closeTime() {
      this.timeFlag = !this.timeFlag;
    },
    setScreen() {
      let visibleWidth = window.innerWidth;
      let visibleHeight = window.innerHeight;
      var widthPercentage = (1.0 * visibleWidth) / 3840;
      var heightPercentage = (1.0 * visibleHeight) / 2160;
      this.scale = Math.min(widthPercentage, heightPercentage);
    },
    // 设置二级路由
    setSecondRouter(route) {
      const routes = this.$router?.options?.routes;
      const { matched } = route ?? {};
      const { name } = matched[0] ?? {};
      if (routes && name) {
        const routeParent = routes.find(item => item.name === name);
        const { children } = routeParent ?? {};
        this.topicSecondRouter = children ?? [];
      }
    },
    // 根据当前图例，查找对应要显示的图层
    legendsToLayers(legends) {
      console.log(legends);
      let layers = [];
      legends.forEach(layer => {
        // 图例可以控制的图层
        this.topicLegends.forEach(legend => {
          if (legend.txt == layer) {
            layers.push(...legend.layers);
          }
        });
        // 不显示图例的图层
        this.hideLegneds.forEach(legend => {
          if (legend.txt == layer) {
            layers.push(...legend.layers);
          }
        });
      });
      return layers;
    },
    // 图层初始化逻辑，专题，关卡，heigHeight改变，都会触发此方法
    appStart(val) {
      // 获取当前专题/highLight中的配置
      let { sceneName, cameraName, sceneWeather, sceneTime, legends, legendConfig } = window.layerContral.cardName[
        val.meta.cname
      ];
      if (!this.appInstance) {
        return;
      }
      // 不同场景
      if (this.sceneName != sceneName && sceneName) {
        // 切换场景，等到场景切换成功再操作图层
        UEapi.Common.switchScene(sceneName);
        // 清除所有轨迹图
        window.layerContral.clearTrailLayer();
      } else {
        // 相同场景
        // 当前专题图例配置
        this.setLegends(legends, legendConfig);
        // 设置相机
        cameraName && this.$store.commit('setCameraInfo', cameraName);
        // 设置天气
        sceneWeather && this.$store.commit('setSceneWeather', sceneWeather);
        // 设置时间
        sceneTime && this.$store.commit('setSceneTime', sceneTime);
        // 根据图例，得到需要操作的图层
        let layers = this.legendsToLayers(legends);
        // 添加图层
        window.layerContral.addCardLayers(layers);
      }
    },
    // 根据配置，从所有图例中组合出图例列表
    setLegends(legends, legendConfig) {
      // 读取图例
      let allLegends = window.layerContral.legends[legendConfig || this.sceneName];
      let showLegends = []; // 图例可控
      let hideLegneds = []; // 图例不可控
      // 得到图例控制的图层和非图例控制的图层
      for (const key in allLegends) {
        let legend = allLegends[key];
        if (legend.showLegend) {
          legend.checked = false;
          showLegends.push(legend);
        } else {
          legend.checked = false;
          hideLegneds.push(legend);
        }
      }
      legends.forEach(item => {
        showLegends.forEach(legend => {
          if (item == legend.txt) {
            legend.checked = true;
          }
        });
      });
      this.topicLegends = showLegends;
      this.hideLegneds = hideLegneds;
    },
    // 场景切换成功
    sceneChangedCallback() {
      let that = this;
      window.appInstance.uniCall('addEventListener', {
        eventName: 'onSceneSwitch',
        callback: res => {
          console.log('onSceneSwitch', res);

          this.$store.commit('setSceneName', res.name);
          // 当前专题图例配置
          let { cameraName, sceneWeather, sceneTime, legends, legendConfig } = window.layerContral.cardName[
            this.highLight
          ];
          this.setLegends(legends, legendConfig);
          // 限制地图
          UEapi.Camera.restrictCamera(this.cameraList[res.name]);
          cameraName && this.$store.commit('setCameraInfo', cameraName);
          sceneWeather && this.$store.commit('setSceneWeather', sceneWeather);
          sceneTime && this.$store.commit('setSceneTime', sceneTime);
          // 添加每个场景专属图层，如地标建筑，城市名称等等
          window.layerContral.addDefaultLayers();
          let layers = this.legendsToLayers(legends);
          window.layerContral.addCardLayers(layers);
        }
      });
    },
    // 场景初始化成功
    sceneInit() {
      window.appInstance.uniCall('addEventListener', {
        eventName: 'onServiceInit',
        callback: () => {
          appInstance.uniCall('getScenesInfo', {}, res => {
            let sceneName = res.scenes.find(item => {
              if (item.default) {
                return item.name;
              }
            }).name;
            console.log('当前场景', sceneName);
            // 设置当前场景相关属性
            this.$store.commit('setSceneName', sceneName);
            this.$store.commit('setAppinstance', true);
            // 设置默认highLight为二级专题
            this.$store.commit('setHighLight', this.subTopic);
            // 读取专题配置
            window.layerContral = AllLayerConfig[this.$route.name];
            // 添加每个场景专属图层，如地标建筑，城市名称等等
            window.layerContral && window.layerContral.addDefaultLayers();

            appInstance.uniCall(
              'setLogMode',
              {
                mode: true
              },
              result => {
                console.log(result);
              }
            );
            // 可以根据初始名字，设置相机视野限制
            UEapi.Camera.restrictCamera(this.cameraList[sceneName]);
          });
        }
      });
    },
    // 图例点击事件
    legendClick(legend) {
      window.layerContral.legendClick(legend);
    },
    // 注册散点点击事件
    mapClickFn() {
      window.addEventListener('onLandmarkLayerClick', res => {
        res = res.detail;
        // UEapi.Camera.focusByLayer({
        //   id: res.idObj,
        //   idLayer: res.idLayer,
        //   layerType: 'LandmarkLayer',
        //   distance: 2000
        // });
        debugger;
        switch (res.idLayer) {
          case 'TGAL-prot':
            this.$store.commit('setShowPortInfo', true);
            break;

          default:
            UEapi.OverlayTip.addOverLayTip(res);

            break;
        }
      });
      window.addEventListener('onTrailLayerClick', res => {
        console.log('onTrailLayerClick', res);
      });
      window.addEventListener('onEventLayerClick', res => {
        res = res.detail;
        UEapi.Camera.focusByLayer({
          id: res.idObj,
          idLayer: res.idLayer,
          layerType: 'eventBubbleLayer',
          distance: 2000
        });
        UEapi.OverlayTip.addOverLayTip(res);
      });
    }
  },
  created() {
    // 接口测试
    // this.$api.page1
    //   .getData()
    //   .then((res) => {
    //     console.log('获取数据成功', res)
    //   })
    //   .catch((err) => {
    //     console.log('获取数据失败', err)
    //   })
  },
  mounted() {
    let that = this;
    //立即执行显示分辨率设置方法
    this.setScreen();
    window.addEventListener('resize', this.setScreen.bind(this));
    document.oncontextmenu = function(ev) {
      ev.preventDefault();
    };
    // 添加场景初始化事件和场景切换成功事件
    this.sceneInit();
    this.sceneChangedCallback();
    // 初始化事件监听
    UEapi.Events.initEventCallback();
    this.mapClickFn();
  },
  computed: {
    ...mapState([
      'topic',
      'subTopic',
      'highLight',
      'appInstance',
      'sceneName',
      'cameraInfo',
      'cameraRotate',
      'sceneTime',
      'sceneWeather'
    ])
  },
  watch: {
    highLight: {
      handler(val) {
        window.layerContral = AllLayerConfig[this.$route.name];
        if (this.appInstance) {
          this.appStart(window.layerContral.cardName[val]);
        }
      },
      deep: true
    },
    $route: {
      handler: function(to, from) {
        // 设置二级路由
        this.setSecondRouter(to);
        // 设置topic名称 ，如果没有二级路由，则二级路由名称和一级路由名称相同，方便程序统一调用
        if (to.matched[1]) {
          this.$store.commit('setTopic', to.matched[1].meta.cname);
          this.$store.commit('setSubTopic', to.matched[1].meta.cname);
        } else {
          this.$store.commit('setSubTopic', to.meta.cname);
          this.$store.commit('setTopic', to.meta.cname);
        }
        if (this.appInstance) {
          // this.appStart(window.layerContral.cardName[val])
          this.$store.commit('setHighLight', this.subTopic);
        }
      },
      deep: true
    },
    cameraInfo: {
      handler(val) {
        UEapi.Camera.setCamera(this.cameraList[val]);
      },
      deep: true
    },
    cameraRotate: {
      handler(val) {
        window.appInstance.uniCall('rotateCamera', {
          enabled: val,
          duration: 360,
          direction: 'clockwise'
        });
      },
      deep: true
    },
    sceneTime: {
      handler(val) {
        window.appInstance.uniCall(
          'setEnvTime',
          {
            envTime: val,
            duration: 2
          },
          result => {
            console.log('设置时间', result.result, result.message);
          }
        );
      },
      deep: true
    },
    sceneWeather: {
      handler(val) {
        window.appInstance.uniCall(
          'setEnvWeather',
          {
            envWeather: val
          },
          result => {
            console.log(result, 111111);
          }
        );
      },
      deep: true
    }
  }
};
</script>

<style lang="less">
@appWidht: 3840px;
@appHeight: 2160px;
#app {
  user-select: none;
  cursor: pointer;
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  pointer-events: all;
  .gis-container {
    width: 100%;
    height: 100%;
    background-color: #000;
    position: absolute;
    left: 50%;
    top: 50%;
    width: @appWidht;
    height: @appHeight;
    overflow: hidden;
  }
  .screen {
    position: absolute;
    background: url(./assets/img/layout/mask.png) no-repeat center center;
    left: 50%;
    top: 50%;
    z-index: 2;
    width: @appWidht;
    height: @appHeight;
    pointer-events: none;
    overflow: hidden;
    .header {
      position: absolute;
      top: 0;
      left: 50px;
      width: 100%;
      height: 140px;
      overflow: hidden;
      pointer-events: none;
      z-index: 10;
      background-position: top left;
      background-repeat: no-repeat;
      background-image: url(./assets/img/layout/header_bg.png);
      .time {
        width: 440px;
        float: right;
        margin-top: -4px;
        margin-right: 50px;
      }
      .clock_pos {
        position: absolute;
        right: 331px;
        top: 30px;
      }
      .closeTime {
        pointer-events: all;
        position: absolute;
        right: 3%;
        top: 25px;
      }
    }
    .main {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: @appHeight;
      pointer-events: none;
      z-index: 5;
    }
    .gis_btn_pos {
      position: absolute;
      left: 920px;
      bottom: 50px;
      z-index: 10;
    }
    .legend_pos {
      position: absolute;
      bottom: 40px;
      right: 920px;
      z-index: 100;
    }
  }
  .layer-container {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 2;
    width: @appWidht;
    height: @appHeight;
    pointer-events: none;
    overflow: hidden;
    .area_pos {
      left: 967px;
      top: 35px;
    }
    .wea_select {
      position: absolute;
      left: 567px;
      top: 21px;
      pointer-events: all;
    }
    .time_select {
      position: absolute;
      left: 697px;
      top: 21px;
      pointer-events: all;
    }
  }
}
</style>
